// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import React from 'react';
import type { VideoPlayerProps } from "@dip/helsecore/src/components/shared/VideoPlayer/VideoPlayer.d";
import { VideoPlayer } from "@dip/helsecore/src/components/shared/VideoPlayer/VideoPlayer";

export default (props: Readonly<VideoPlayerProps>) => <VideoPlayer data-noindex="true" {...props} />
